
<progress class="bar" :max="max" :value="value"/>
